import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
// Components
import { Snackbar } from "@/components/index";
// Entities
import { Company, User, Stat } from "@/entities/index";

@Component({
  components: {
    Snackbar,
  },
})
export default class Stats extends Vue {
  username = "";
  email = "";
  company = "";

  users: User[] = [];
  companies: Company[] = [];
  stats: Stat[] = [];

  nbUsers = 0;
  nbActions = 0;

  dialogDeleteStats = false;
  snackbarDeleteStats = false;

  headers = [
    {
      text: "Utilisateur",
      value: "user.username",
      align: "start",
    },
    { text: "Email", value: "user.email" },
    { text: "Prénom", value: "user.firstname" },
    { text: "Nom", value: "user.lastname" },
    { text: "Rattaché à", value: "user.company.name" },
    { text: "Nb total de connexion", value: "user._count.actionLogs" },
    { text: "Dernière connexion", value: "createdAt" },
    { text: "Dernière action", value: "action" },
  ];

  async allUsers(): Promise<void> {
    this.users = (await axios.get(`/api/users`)).data as User[];
  }

  async allCompanies(): Promise<void> {
    this.companies = (await axios.get(`/api/companies`)).data as Company[];
  }

  async allStats(): Promise<void> {
    this.stats = (await axios.get(`/api/stats/actions`)).data as Stat[];

    this.stats.forEach((stat) => {
      stat.createdAt = new Date(stat.createdAt).toLocaleString("en-GB");
    });
  }

  async deleteStats(): Promise<void> {
    await axios.delete(`/api/stats/actions`);
    this.dialogDeleteStats = false;
    this.snackbarDeleteStats = true;
    this.allStats();
  }

  async allGeneralStats(): Promise<void> {
    const { nbUsers, nbActions } = (await axios.get(`/api/stats/general`)).data;
    this.nbUsers = nbUsers;
    this.nbActions = nbActions;
  }

  mounted(): void {
    this.allUsers();
    this.allCompanies();
    this.allStats();
    this.allGeneralStats();
  }

  // ========== OTHER METHODS ========== //

  colorRow(item: any): any {
    const position = this.stats.indexOf(item, 0);
    if (position % 2 == 0) {
      return "light-green lighten-5";
    }
  }

  showSnackbar(): void {
    const snackbar = this.$refs.snackbar as Snackbar;
    snackbar.show();
  }

  convertToCSV(json: any): string {
    if (
      json.user.username === null ||
      json.user.username === undefined ||
      json.user.username === ""
    ) {
      json.user.username = "Pas de nom d'utilisateur renseigné";
    }
    if (
      json.user.email === null ||
      json.user.email === undefined ||
      json.user.email === ""
    ) {
      json.user.email = "Pas d'email renseigné";
    }
    if (
      json.user.firstname === null ||
      json.user.firstname === undefined ||
      json.user.firstname === ""
    ) {
      json.user.firstname = "Pas de prénom renseigné";
    }
    if (
      json.user.lastname === null ||
      json.user.lastname === undefined ||
      json.user.lastname === ""
    ) {
      json.user.lastname = "Pas de nom renseigné";
    }
    if (
      json.action === null ||
      json.action === undefined ||
      json.action === ""
    ) {
      json.action = "Aucune action";
    }
    return `"${json.user.username}";"${json.user.email}";"${json.user.firstname}";"${json.user.lastname}";"${json.user.company.name}";"${json.user._count.actionLogs}";"${json.createdAt}";"${json.action}"`;
  }

  downloadCSV(): void {
    const csvJSON = this.stats.map((json: any) => this.convertToCSV(json));
    csvJSON.unshift(this.headers.map((header: any) => header.text).join(";"));
    const csvData = csvJSON.join("\n");
    const csvBlob = new Blob([csvData], { type: "text/csv;charset=utf-8" });
    const csvUrl = URL.createObjectURL(csvBlob);
    const link = document.createElement("a");
    link.href = csvUrl;
    link.download = "Stats.csv";
    link.click();
  }

  clearFilters(): void {
    this.username = "";
    this.email = "";
    this.company = "";
  }
}
